var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"fixed-header":"","height":"55vh","headers":_vm.headers,"items":_vm.matchedrulesdata,"items-per-page":10,"dense":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }